<template>
  <div class="forgot-password">
    <h2>Set my password</h2>
    <div class="description">
      <p>
        Enter the email associated with your account. If the email is registered
        in our system, we'll email you a link to create a new password.
      </p>
    </div>
    <div class="form-group">
      <input
        type="text"
        name="Email"
        v-model="Email"
        class="form-control"
        placeholder="Enter account email"
        required="required"
        id="emailInput"
      />
    </div>
    <div class = "buttonContainer">
        <ButtonSubmit @click="resetPassword()" label="Set My Password" />
    </div>
    <div><router-link to="/login">Return to Sign In page</router-link></div>
    <div class="btm-msg">
      <p>
        Unsure which email you used? <br />
        Look at any email received from us to <br />
        find your email associated with your account. <br />
        If you've not received an email, <br />contact, our helpdesk on
        Help@TalentSage.com.
      </p>
    </div>
  </div>
</template>

<script>
import ButtonSubmit from "./ButtonSubmit.vue";
import CryptoJS from "crypto-js";
import api from "../api/api.js";
import {flashMessage} from "../functions.js";

export default {
  components: { ButtonSubmit },
  name: "ForgotPasswordScreen",
  data: () => ({
    isLoggedIn: false,
    Email: ""
  }),
  mounted() {
    if (this.$route.query.email) {
      try {
        let decryptedEmail = this.decrypt(
          decodeURIComponent(this.$route.query.email),
          "seed"
        );
        this.Email = decryptedEmail;
      } catch (e) {
        console.error("Error decrypting email:", e);
      }
    }
  },
  methods: {
    encrypt(src, passphrase) {
      return CryptoJS.AES.encrypt(src, passphrase).toString();
    },
    decrypt(src, passphrase) {
      const bytes = CryptoJS.AES.decrypt(src, passphrase);
      return bytes.toString(CryptoJS.enc.Utf8);
    },
    resetPassword() {
      if (this.Email == "" || this.Email == null || this.Email == undefined) {
        flashMessage(this.$flashMessage, '#F47820', '#ffffff', "Please Enter a valid Email Address!")
        return null;
      }

      api.post("password-reset/request", { email: this.Email.trim() })
        .then((response) => {
          if (response.data.success) {
            this.$flashMessage.show({
              type: "success",
              title: "Password reset email sent!",
              message: "If an account exists with this email, you will receive password reset instructions.",
            });
            this.Email = "";
          } else {
            this.$flashMessage.show({
              type: "error",
              title: response.data.message || "Something went wrong",
              message: "",
            });
          }
        })
        .catch((e) => {
          this.$flashMessage.show({
            type: "error",
            title: "An error occurred. Please try again.",
            message: "",
          });
          console.error("Password reset request error:", e);
        });
    },
  },
};
</script>

<style scoped>
.forgot-password {
  background: white;
  margin-left: auto;
  margin-right: auto;
  max-width: 600px;
  padding: 20px;
  margin-top: 20px;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 2px 10px -4px #000000;
}
.btn {
  background-color: #e67829;
  width: 100%;
  color: #fff;
  fill: #fff;
  font-size: 100%;
  line-height: 1.15;
  font-weight: 500;
  margin: 6px 0;
  border: 0;
  outline: 0;
  border-radius: 2px;
  cursor: pointer;
  letter-spacing: 0.03em;
  padding: 10px 26px;
  box-shadow: 0 0 2px rgb(0 0 0 / 12%), 0 2px 2px rgb(0 0 0 / 20%);
  transition: all 0.2s ease-in-out;
  margin-top: 5px;
  margin-bottom: 10px;
}

h2 {
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  margin-top: 20px;
  text-align: left;
}

.description {
  text-align: left;
  margin-top: 20px;
}

.form-group input {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.2em;
  letter-spacing: 0.00938em;
  color: rgba(0, 0, 0, 0.87);
  box-sizing: border-box;
  cursor: text;
  display: inline-flex;
  -webkit-box-align: center;
  width: 100%;
  position: relative;
  border-radius: 4px;
  padding: 16.5px 14px;
  margin-bottom: 10px;
}
.form-control {
  border: 2px solid #0e5071;
}
.btm-msg {
  text-align: center;
  margin-top: 50px;
}
.buttonContainer {
  display: flex;
  justify-content: space-around;
  margin-top: 8px;
  margin-bottom: 12px;
}
input, select, option, textarea {
  border: 1px solid grey;
}
</style>